import { useEditingElementStore, useParametersStore } from "../../api/Zustand";
import { useRightSidePanelStore } from "../../state management/zustand/editor-elements-stores";

// Right side panel inner components
import SceneEditing from "./RightSidePanel/SceneEditing";
import LinkEditing from "./RightSidePanel/LinkEditing";
import WaypointEditing from "./RightSidePanel/WaypointEditing";
import PopupEditing from "./RightSidePanel/PopupEditing";
import TourInfoEditing from "./RightSidePanel/TourInfoEditing";
import GroupsEditing from "./RightSidePanel/GroupsEditing";
import QuizEditing from "./RightSidePanel/QuizEditing";
import AudioPopupEditing from "./RightSidePanel/AudioPopupEditing";
import WaypointExpIcon from "../Icons/WaypointExpIcon";
import { getLanguageFile } from "../common/GetLanguageFile";
import EscapeRoomPopupsEditor from "./escape-room/EscapeRoomPopupsEditor";

function RightSidePanel() {
  const { tourID } = useParametersStore();

  const { type, id } = useEditingElementStore();

  const rightPanel = useRightSidePanelStore();

  return (
    <div
      className="right-side-panel"
      id={rightPanel.isOpen ? "open" : "closed"}
      onClick={() => {
        if (!rightPanel.isOpen) rightPanel.setOpen(true);
      }}
    >
      <div
        style={{
          opacity: rightPanel.isOpen ? 1 : 0,
          transition: "all 150ms",
          transitionDelay: "250ms",
          height: "100%",
        }}
      >
        {rightPanel.isOpen && (
          <div className="right-side-panel-content">
            <button
              onClick={() => {
                rightPanel.setOpen(false);
              }}
              id="close-panel"
            >
              <span>{getLanguageFile("generics.close")}</span>
              <WaypointExpIcon width={"1rem"} height={"1rem"} />
            </button>

            {type === "scene" ? (
              <SceneEditing tourID={tourID} />
            ) : type === "link" ? (
              <LinkEditing id={id as string} tourID={tourID} />
            ) : type === "transition" ? (
              <WaypointEditing id={id as string} tourID={tourID} />
            ) : type === "popup" ? (
              <PopupEditing id={id} tourID={tourID} />
            ) : type === "groups" ? (
              <GroupsEditing tourID={tourID} />
            ) : type === "quiz" ? (
              <QuizEditing id={id as string} tourID={tourID} />
            ) : type === "audio" ? (
              <AudioPopupEditing id={id as string} tourID={tourID} />
            ) : type === "escapeRoomPops" ? (
              <EscapeRoomPopupsEditor tourID={tourID} />
            ) : (
              <TourInfoEditing tourID={tourID} />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default RightSidePanel;
